module.exports = __webpack_public_path__ + "media/react/features/event-creation-wizard/steps/event-areas/assets/stage-2c28ec5d7c2354240e99ceb1741d143d.png";